import { getToken, getLogin, isImpersonationSession } from '../../ressources/functions/helper';

// Function to return token
export const sbToken = () => {
  return getToken();
};

// Function to return Login
export const sbLogin = () => {
  return getLogin();
};

// Function to return valid
export const sbValid = () => {
  return isImpersonationSession() ? sessionStorage.getItem("SB_IMPERSONATION_VALID") : localStorage.getItem("valid");
};

